import { Api } from '../helpers';

const merchantModel = {
  getMerchantData(params) {
    const queryParams = params;
    const path = 'merchant/get_basic_info';
    return Api.get({ path, queryParams });
  },

  getMerchantNumber(params) {
    const queryParams = params;
    const path = 'merchant/get_number';
    return Api.get({ path, queryParams });
  },

  getMerchantHistory(params) {
    const queryParams = params;
    const path = 'merchant/get_history';
    return Api.get({ path, queryParams });
  },
};

export default merchantModel;
